import { createIcon } from './utils/createIcon.js';

export default createIcon({
  paths: [
    'M19 8V7h-2V4.9c0-1-.8-1.9-1.9-1.9H13V1h-1v2h-2V1H9v2H7V1H6v2H3.9C2.8 3 2 3.8 2 4.9V7H0v1h2v2H0v1h2v2H0v1h2v2.1c0 1 .8 1.9 1.9 1.9H6v2h1v-2h2v2h1v-2h2v2h1v-2h2.1c1 0 1.9-.8 1.9-1.9V14h2v-1h-2v-2h2v-1h-2V8h2zM6 17v-2c0-.6.4-1 1-1h5c.6 0 1 .4 1 1v2H6zm10-.9c0 .5-.4.9-.9.9H14v-2c0-1.1-.9-2-2-2H7c-1.1 0-2 .9-2 2v2H3.9c-.5 0-.9-.4-.9-.9V4.9c0-.5.4-.9.9-.9h11.2c.5 0 .9.4.9.9v11.2z',
  ],
  height: 20,
  width: 20,
});
